import type { Product } from './api.js';

/**
 * URL para "Ver" a oferta na Shopee.
 *
 * Usa deliberadamente o link ORIGINAL, não o de afiliado: abrir o próprio link
 * de afiliado registra um clique seu no relatório de conversão — clique que
 * nunca vira venda, sujando a métrica de cada canal e parecendo autorreferência.
 *
 * Ofertas antigas (buscadas antes desta coluna existir) não têm o link
 * original; nesse caso não oferecemos o botão em vez de abrir o de afiliado.
 */
export function viewUrl(offer: Product): string | null {
  return offer.originalUrl ?? null;
}
